k<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
import SearchAddrAlert from './SearchAddrAlert'

export default {
  name: 'Register',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      layoutTitle: '',
      includeLayoutHtml: '',
      visible: false,
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      },
      delivInfo: {
        zipno: '',
        address1: '',
        address2: ''
      } //주소지 정보
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.secondSubTemplate)) {
      this.getEmptyTemplate('wepRegister.html')
    } else {
      this.includeHtml = wepHtmlToString.secondSubTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.secondSubTemplate = res
        this.includeHtml = wepHtmlToString.secondSubTemplate
      })
    },
    fnConfirm () {
      this.$emit('confirm', '2')
    },
    fnPrev () {
      this.fnTab('1')
    },
    fnApply () {
      this.fnTab('3')
    },
    fnTab (arg) {
      let obj = {
        stepNum: arg,
        params: {}
      }

      if (arg !== '1') {
        obj.params = this.documentValidate()

        if (obj.params.flag) {
          this.$emit('fnTab', obj)
        }
      } else {
        this.$emit('fnTab', obj)
      }
    },
    fnCheckAll (arg) {
      let allCheck = document.getElementById('checkAll').checked
      let itemCnt = document.getElementById('itemCount').value
      let idx = itemCnt - arg
      for (let i = 0; i < arg; i++) {
        if (allCheck) {
          document.getElementById('mtItem' + (idx + ( i + 1))).checked = true
        } else {
          document.getElementById('mtItem' + (idx + ( i + 1))).checked = false
        }
      }
    },
    fnOpenPolicy (idx) {
      let obj = {
        stepNum: 0,
        idx: idx
      }
      this.$emit('fnTab', obj)
    },
    closePopup () {
      this.visible = false
      document.querySelector('body').style.overflow = ''
      // this.setOverflow(this.visible)
    },
    fnCheck (arg) {
      let itemCnt = document.getElementById('itemCount').value
      let checkYn
      let idx = itemCnt - arg
      var checkLen = 0
      for (var i = 0; i < arg; i++) {
        checkYn = document.getElementById('mtItem' + (idx + ( i + 1))).checked
        if (!checkYn) {
          checkLen++
        }
      }
      if (checkLen === 0) {
        document.getElementById('checkAll').checked = true
      } else {
        document.getElementById('checkAll').checked = false
      }
    },
    findAddr () {
      // 주소찾기 팝업 오픈 후 주소 데이터 받기
      this.$popup.openModal(this.$el, SearchAddrAlert, {} ).then((result) => {
        if (result.data === undefined) {
        } else {
          this.$set(this, 'addError', '')
          this.delivInfo.zipno = result.data.zipno
          this.delivInfo.address1 = result.data.road
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Register.vue